import {
  type NodeType,
  isCloudConstructNodeType,
  isDeviceType,
  isNonNullable,
} from '@ipfabric/utils';

// (NIM-24243) Allow nodes which exist in vDevice collection, plus all cloud constructs
export const hasNodeDetailTab = (nodeType: NodeType | null): boolean =>
  isNonNullable(nodeType) &&
  nodeType !== 'fex' &&
  nodeType !== 'host' &&
  nodeType !== 'phone' &&
  (isDeviceType(nodeType) || isCloudConstructNodeType(nodeType));
